import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/france.png'
import _imports_1 from '@/assets/images/royaume-uni.png'
import _imports_2 from '@/assets/images/espagne.png'
import _imports_3 from '@/assets/images/italie.png'


const _hoisted_1 = { class: "flex flex-wrap justify-end gap-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_5 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_7 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_14 = ["value"]

import { ref } from 'vue'
import { DataCard } from '@/components'
import { translateVendeurDescriptionFromFrench } from '@/api/vendeur'
import type { GeneralInformationFormData } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionSection',
  props: {
    formData: {},
    saving: { type: Boolean },
    disableSave: { type: Boolean }
  },
  emits: ["update:formData", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const translating = ref(false)
const translationMessage = ref('')
const translationError = ref(false)

const translateFromFrench = async () => {
  const french = props.formData.description.fr.trim()
  if (!french || translating.value) return
  const hasExistingTranslations = ['en', 'es', 'it'].some(
    language => props.formData.description[language as 'en' | 'es' | 'it'].trim(),
  )
  if (hasExistingTranslations && !window.confirm('Remplacer les traductions anglaise, espagnole et italienne actuelles ?')) return

  translating.value = true
  translationMessage.value = ''
  translationError.value = false
  try {
    const translations = await translateVendeurDescriptionFromFrench(french)
    const description = {
      ...props.formData.description,
      en: translations.en || props.formData.description.en,
      es: translations.es || props.formData.description.es,
      it: translations.it || props.formData.description.it,
    }
    const updatedFormData = {
      ...props.formData,
      description,
      baseline: { ...props.formData.baseline, en: description.en, es: description.es, it: description.it },
    }
    emit('update:formData', updatedFormData)
    translationMessage.value = 'Traductions générées. Vérifie-les puis clique sur Sauvegarder.'
  } catch (value) {
    translationError.value = true
    translationMessage.value = value instanceof Error ? value.message : 'Impossible de traduire la description.'
  } finally {
    translating.value = false
  }
}

const updateFormData = (field: string, value: any) => {
  const updatedFormData = { ...props.formData }
  const keys = field.split('.')
  let current: any = updatedFormData
  
  for (let i = 0; i < keys.length - 1; i++) {
    current = current[keys[i]]
  }
  
  current[keys[keys.length - 1]] = value

  // Synchroniser baseline avec description automatiquement
  if (keys[0] === 'description' && keys.length === 2) {
    const lang = keys[1]
    if (updatedFormData.baseline) {
      updatedFormData.baseline = { ...updatedFormData.baseline, [lang]: value }
    }
  }

  emit('update:formData', updatedFormData)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Description magasin",
    icon: "fas fa-globe",
    "icon-color": "text-blue-600",
    "icon-bg-color": "bg-blue-100",
    class: "w-full"
  }, {
    "header-actions": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          onClick: translateFromFrench,
          disabled: _ctx.saving || translating.value || !_ctx.formData.description.fr.trim(),
          class: "px-4 py-2 border border-blue-600 text-blue-700 bg-white rounded-lg hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(translating.value ? 'fas fa-spinner fa-spin' : 'fas fa-language')
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(translating.value ? 'Traduction...' : 'Traduire le français'), 1)
        ], 8, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save'))),
          disabled: _ctx.saving || translating.value || _ctx.disableSave,
          class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        }, [
          (_ctx.saving)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : (_openBlock(), _createElementBlock("i", _hoisted_5)),
          _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Sauvegarde...' : 'Sauvegarder'), 1)
        ], 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      (translationMessage.value)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["mb-4 text-sm", translationError.value ? 'text-red-700' : 'text-green-700'])
          }, _toDisplayString(translationMessage.value), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Français",
                class: "w-5 h-3"
              })
            ]),
            _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Français")
          ], -1)),
          _createElementVNode("textarea", {
            value: _ctx.formData.description.fr,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (updateFormData('description.fr', ($event.target as HTMLTextAreaElement).value))),
            rows: "8",
            placeholder: "Décrivez votre entreprise en français...",
            class: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 resize-none transition-colors"
          }, null, 40, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "English",
                class: "w-5 h-3"
              })
            ]),
            _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "English")
          ], -1)),
          _createElementVNode("textarea", {
            value: _ctx.formData.description.en,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (updateFormData('description.en', ($event.target as HTMLTextAreaElement).value))),
            rows: "8",
            placeholder: "Describe your company in English...",
            class: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 resize-none transition-colors"
          }, null, 40, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Español",
                class: "w-5 h-3"
              })
            ]),
            _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Español")
          ], -1)),
          _createElementVNode("textarea", {
            value: _ctx.formData.description.es,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (updateFormData('description.es', ($event.target as HTMLTextAreaElement).value))),
            rows: "8",
            placeholder: "Describe su empresa en español...",
            class: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 resize-none transition-colors"
          }, null, 40, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "Italiano",
                class: "w-5 h-3"
              })
            ]),
            _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Italiano")
          ], -1)),
          _createElementVNode("textarea", {
            value: _ctx.formData.description.it,
            onInput: _cache[4] || (_cache[4] = ($event: any) => (updateFormData('description.it', ($event.target as HTMLTextAreaElement).value))),
            rows: "8",
            placeholder: "Descrivi la tua azienda in italiano...",
            class: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 resize-none transition-colors"
          }, null, 40, _hoisted_14)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})